import { Box, ListItem, OrderedList, Text, Link as ChakraLink } from '@chakra-ui/react';

// @ts-ignore There is no types for this package
import AnchorLink from 'react-anchor-link-smooth-scroll-v2';
import _ from 'lodash';
import { configFile } from '@/config';

export default function TableOfContent({ post }: any) {

  return (
    <Box>
      <Text fontWeight="700" fontSize="18px" mb="12px" className="small-title">
        Índice
      </Text>
      <Box
        width="100%"
        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
        borderRadius="8px"
        bgColor="#fff"
        overflow="hidden"
        padding="28px"
      >
        <OrderedList
          display="flex"
          marginLeft="0"
          flexDir="column"
          rowGap="24px"
          style={{ counterReset: 'item' }}
          listStyleType="none"
        >
          {Object.entries(Array.from(post.matchAll(/^## (.*)$/gm))).map(([index, match]) => {
            const headerText: string = (match as [string, string])[1];

            return (
              <ListItem key={index} style={{ counterIncrement: 'item' }}>
                <ChakraLink
                  offset="120"
                  display="block"
                  as={AnchorLink}
                  fontWeight="500"
                  fontSize="16px"
                  lineHeight="24px"
                  position="relative"
                  p="0 0 0 35px !important"
                  color="gray.600"
                  w="auto"
                  _hover={{
                    textDecor: 'none',
                    color: "gray.600",
                  }}
                  _before={{
                    content: 'counter(item)',
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '24px',
                    height: '24px',
                    bgColor: "purple.50",
                    borderRadius: '100%',
                    marginRight: '16px',
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    color: configFile.primaryAccentColor,
                    fontWeight: '600',
                  }}
                  href={`#${_.kebabCase(headerText)}`}
                >
                  {headerText}
                </ChakraLink>
              </ListItem>
            );
          })}
        </OrderedList>
      </Box>
    </Box>
  );
}
